module.exports = __webpack_public_path__ + "img/mon_24.6d357ad8.png";